import { CompanySettingsResponse, LanguageResponse, CurrentCultureResponse} from '@/types/service-response';
import { CurrentCulture, Language} from '@/types'

export class CompanySettings {
  private constructor (
    readonly applicationName: string,
    readonly cultures: CurrentCulture[],
    readonly currentCulture: CurrentCulture,
    readonly favicon: string,
    readonly language: Language,
    readonly languages: Language[],
    readonly logo: string,
    readonly nightShiftIndicator: boolean, //nachtschichtAnzeige
    readonly nameFormat: boolean,
    readonly planDaysPlanWeeksPlanYears: boolean, //planTagePlanWochenPlanJahre
    readonly planningWithAddress: boolean,
    readonly primaryColor: string,
    readonly provPlanning: string,
    readonly qualityByCompetences: boolean, //qualityByKompetezen
    readonly qualityByEmployee: boolean, //qualityByMitarbeiter
    readonly secondaryColor: string,
    readonly showAdditionalFields: string, //showZusatzfelder
    readonly starsColor: string,
    readonly starsNumber: number,
    readonly startingDayOfWeek: string, //startingDayofWeek
    readonly suggestShiftNamesFlag: boolean,
    readonly version: string,
    readonly versionInfos: Array<any>,
    readonly weekTimeModel: boolean, //wochenzeitmodell
  ) {}

  public static createFromResponse (data: Array<CompanySettingsResponse>): CompanySettings {
    let result: Array<CompanySettings> = []
    
    result = data.map((item: CompanySettingsResponse) => {
      let cultures: Array<CurrentCulture> = []
      item.cultures.forEach((item: CurrentCultureResponse) => {
        cultures.push({
        cultureDisplayName: item.cultureDisplayName,
        cultureId: item.cultureID,
        cultureName: item.cultureName,
        isoCode: item.isoCode
        })
      })
      let currentCulture: CurrentCulture = {
        cultureDisplayName: item.currentCulture.cultureDisplayName,
        cultureId: item.currentCulture.cultureID,
        cultureName: item.currentCulture.cultureName,
        isoCode: item.currentCulture.isoCode
      }
      let language: Language = {
        languageId: item.language.languageID,
        isoCode: item.language.isoCode,
        isoName: item.language.isoName,
        nativeName: item.language.nativeName
      }
      let languages: Array<Language> = []
      item.languages.forEach((item: LanguageResponse) => {
        languages.push({
          languageId: item.languageID,
          isoCode: item.isoCode,
          isoName: item.isoName,
          nativeName: item.nativeName
        })
      })
      return new CompanySettings(
        item.applicationName,
        cultures,
        currentCulture,
        item.favicon,
        language,
        languages,
        item.logo,
        item.nachtschichtAnzeige,
        item.nameFormat,
        item.planTagePlanWochenPlanJahre,
        item.planningWithAdress,
        item.primaryColor,
        item.provPlanning,
        item.qualityByKompetezen,
        item.qualityByMitarbeiter,
        item.secondaryColor,
        item.showZusatzfelder,
        item.starsColor,
        item.starsNumber,
        item.startingDayofWeek,
        item.suggestShiftnamesFlag,
        item.version,
        item.versionInfos,
        item.wochenzeitmodell,
      )
    })
    
    return result[0]
  }

}
